import { useEffect } from "react"

export default function Deeplink() {
  useEffect(() => {}, [])

  return <> </>
}
